import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const SunIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </svg>
);

export default SunIcon;
